import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { getBillingHistory, getWhiteLabelInfo } from 'redux/modules/billing';
import { Spinner, PageHeader } from 'components';
import moment from 'moment';
import * as styles from './Invoice.scss';
var Invoice = (_dec = connect(function (state) {
  return {
    config: state.config,
    billingHistory: state.billing.billingHistory,
    loadingBillingHistory: state.billing.loadingBillingHistory,
    whiteLabelInfo: state.billing.whiteLabelInfo
  };
}, {
  getBillingHistory: getBillingHistory,
  getWhiteLabelInfo: getWhiteLabelInfo
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Invoice, _Component);

  var _super = _createSuper(Invoice);

  function Invoice() {
    var _this;

    _classCallCheck(this, Invoice);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderBilleeAddress", function () {
      var invoice = _this.props.invoice;
      var address = invoice.billee.address;
      var cityLine = address && [address.locality, address.region].filter(function (c) {
        return c && c !== '';
      }).join(' ');
      var zipLine = address && [address.postcode, address.country].filter(function (c) {
        return c && c !== '';
      }).join(', ');
      return /*#__PURE__*/React.createElement("div", {
        className: styles.addressLineWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine,
        style: {
          marginTop: 8
        }
      }, invoice.billee.org.name), address && address.address1 && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, address.address1), address && address.address2 && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, address.address2), address && cityLine && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, cityLine), address && zipLine && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, zipLine));
    });

    _defineProperty(_assertThisInitialized(_this), "renderBillerAddress", function () {
      var invoice = _this.props.invoice;
      var address = invoice.biller.address;
      var cityLine = [address.locality, address.region].filter(function (c) {
        return c;
      }).join(', ');
      var zipLine = [address.postcode, address.country].filter(function (c) {
        return c;
      }).join(', ');
      return /*#__PURE__*/React.createElement("div", {
        className: styles.addressLineWrap
      }, address && address.address1 && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, address.address1), address && address.address2 && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, address.address2), address && cityLine && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, cityLine), address && zipLine && /*#__PURE__*/React.createElement("span", {
        className: styles.addressLine
      }, zipLine));
    });

    _defineProperty(_assertThisInitialized(_this), "renderRow", function (rowData) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.row
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.col1,
        style: {
          whiteSpace: 'pre-line',
          wordBreak: 'normal'
        }
      }, rowData.description ? rowData.description : rowData.planName ? rowData.planName : 'Unknown plan'), /*#__PURE__*/React.createElement("span", {
        className: styles.col2
      }, rowData.description && rowData.description.indexOf('Remaining time') === 0 ? '' : rowData.amount.perUnitDisplay), /*#__PURE__*/React.createElement("span", {
        className: styles.col3
      }, rowData.quantity ? rowData.quantity : 1), /*#__PURE__*/React.createElement("span", {
        className: styles.col4
      }, rowData.amount.display));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTable", function () {
      var invoice = _this.props.invoice;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.col1
      }, "Name"), /*#__PURE__*/React.createElement("span", {
        className: styles.col2
      }, "Price"), /*#__PURE__*/React.createElement("span", {
        className: styles.col3
      }, "Quantity"), /*#__PURE__*/React.createElement("span", {
        className: styles.col4
      }, "Amount")), invoice.oneTimeCharge ? _this.renderRow({
        planName: 'One Time Charge',
        amount: {
          display: invoice.amount
        }
      }) : _this.collapsedLineItems(invoice.lineItems).map(function (section) {
        return section.sort(function (a, b) {
          if (a.forOrganizations && a.forOrganizations.length > 0) {
            return -1;
          }

          return 1;
        }).map(function (item) {
          return _this.renderRow(item);
        });
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "collapsedLineItems", function (lineItems) {
      var obj = [[], []];
      var discountQuantity = 0;
      lineItems.forEach(function (li) {
        discountQuantity += li.amount.value < 0 ? 1 : 0;
        obj["".concat(li.amount.value < 0 ? 0 : 1)].push(li);
      });
      var data = [function () {
        var reduced = obj[0].reduce(function (acc, obj) {
          if (!acc) {
            acc = [];
          }

          if (!acc[0]) {
            acc[0] = {
              description: 'Prorated discounts',
              quantity: discountQuantity,
              amount: {
                perUnitDisplay: '',
                value: 0
              }
            };
          }

          acc[0].amount.value += obj.amount.value;
          return acc;
        }, []);

        if (reduced && reduced.length === 1) {
          reduced[0].amount.display = _this.formatCurrency(reduced[0].amount.value);
          return reduced;
        }

        return [];
      }(), obj[1]];
      return data.reverse();
    });

    return _this;
  }

  _createClass(Invoice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getWhiteLabelInfo(this.props.invoice.orgId);
    }
    /** *********************************************************
     RENDER
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var invoice = this.props.invoice;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("section", {
        className: styles.logoRow
      }, /*#__PURE__*/React.createElement("img", {
        src: (!invoice.orgTypeId || invoice.orgTypeId && "".concat(invoice.orgTypeId) !== '2') && this.props.whiteLabelInfo && this.props.whiteLabelInfo.details ? this.props.whiteLabelInfo.details.logoUrl[0] : 'https://likeabucket.s3.amazonaws.com/76q7m7c40g_1480436487184.png',
        className: styles.logo
      }), this.renderBillerAddress()), /*#__PURE__*/React.createElement("section", {
        className: styles.columnsRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.header
      }, "Billed To"), this.renderBilleeAddress()), /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.header
      }, "Date"), /*#__PURE__*/React.createElement("span", {
        className: styles.line
      }, invoice.createdDate)), /*#__PURE__*/React.createElement("div", {
        className: styles.col
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.header
      }, "Invoice Number"), /*#__PURE__*/React.createElement("span", {
        className: styles.line
      }, invoice.invoiceNumber))), /*#__PURE__*/React.createElement("section", {
        className: styles.tableWrap
      }, this.renderTable()), /*#__PURE__*/React.createElement("section", {
        className: styles.totalsRow
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.totalsLine
      }, "Total", /*#__PURE__*/React.createElement("span", null, invoice.amount)), /*#__PURE__*/React.createElement("span", {
        className: styles.totalsLine
      }, "Payment", /*#__PURE__*/React.createElement("span", null, invoice.amountPaid !== '$0.00' ? "-".concat(invoice.amountPaid) : invoice.amountPaid)), /*#__PURE__*/React.createElement("span", {
        className: styles.totalsLine
      }, "Balance Due", /*#__PURE__*/React.createElement("span", null, invoice.balanceDue)), invoice.amountRefunded && /*#__PURE__*/React.createElement("span", {
        className: styles.totalsLine
      }, "Refunded", /*#__PURE__*/React.createElement("span", null, invoice.amountRefunded))));
    }
  }]);

  return Invoice;
}(Component)) || _class);
export { Invoice as default };